import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Header, Divider } from 'semantic-ui-react';

import {
  getStudentBalance,
  changeStudentBalance,
} from '../../state/changebalance/actions';

import { calculateUpdatedValues } from './helpers';
import { LoadingModal } from 'Components/loading/LoadingModal';
import { ChangeBalanceLine } from './ChangeBalanceLine';
import { ChangeBalanceGridHeader } from './ChangeBalanceGridHeader';
import { ChangeBalanceSummary } from './ChangeBalanceSummary';

class ChangeBalanceModalContainer extends Component {
  state = {
    payments: {
      adjustment: 0,
    },
    purchases: {
      adjustment: 0,
    },
  };

  componentDidMount() {
    this.props.getStudentBalance(this.props.student.IdSeed);
  }

  canEdit = () => {
    const {
      student: { BillingAcc, Id },
    } = this.props;
    return BillingAcc === Id;
  };

  onChangeAdjustment = (field, value) => {
    this.setState({
      [field]: {
        ...this.state[field],
        adjustment: value,
      },
    });
  };

  onActionClick = () => {
    if (this.canEdit()) {
      const result = calculateUpdatedValues(this.props.balance, this.state);

      this.props.changeStudentBalance(
        result.payments.updatedValue,
        result.purchases.updatedValue
      );
    } else {
      this.props.modalProps.onClose();
    }
  };

  renderModalContent(billingAcc) {
    if (this.canEdit()) {
      const result = calculateUpdatedValues(this.props.balance, this.state);

      return (
        <div>
          <ChangeBalanceGridHeader />
          <Divider />
          <ChangeBalanceLine
            showHeader
            title={'PAYMENTS'}
            onChange={e => this.onChangeAdjustment('payments', e.target.value)}
            {...result.payments}
          />
          <Divider />
          <ChangeBalanceLine
            title={'PURCHASES'}
            onChange={e => this.onChangeAdjustment('purchases', e.target.value)}
            {...result.purchases}
          />
          <Divider />
          <ChangeBalanceSummary balance={result.balance} />
        </div>
      );
    }

    return `Balance adjustments to this account must be made under Account #${billingAcc}`;
  }

  render() {
    const { modalProps, student, fetching, submitting } = this.props;
    const { open, onClose } = modalProps;
    const { BillingAcc, FirstName, LastName } = student;
    const title = `Change Balance - ${FirstName} ${LastName}`;

    return (
      <Modal open={open} onClose={onClose} closeIcon size={'tiny'}>
        {fetching && <LoadingModal />}
        <Header content={title} icon={'dollar'} />
        <Modal.Content className="p-t-0">
          {this.renderModalContent(BillingAcc)}
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={this.onActionClick}
            inverted
            color="orange"
            size="big"
            content={this.canEdit() ? 'Save' : 'OK'}
            type="submit"
            loading={submitting}
            disabled={submitting}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = ({ AccountSetupState }) => {
  return {
    balance: AccountSetupState.studentBalance.data,
    fetching: AccountSetupState.studentBalance.fetching,
    submitting: AccountSetupState.studentBalance.submitting,
  };
};

export const ChangeBalanceModal = connect(
  mapStateToProps,
  {
    getStudentBalance,
    changeStudentBalance,
  }
)(ChangeBalanceModalContainer);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/changebalance/ChangeBalanceModal.js